/**
 * Create by Alex
 * Description:
 *
 * ------ maintenance history ------
 * 2025/5/20 added to support impacted home screen
 */

import { businessConstants } from '../constants/business.constants';

export class ImpactedHomeScreenConfig {
    name: string;
    type: string;
    setting: string;

    /**
     * Parse the impacted home screen from response
     * @param serverResponse
     * @returns A array of impacted impacted home screen
     */
    static parse(serverResponse): Array<ImpactedHomeScreenConfig> {
        const serverRes = serverResponse['user-screen-list'];
        if (!serverRes) {
            return null;
        }

        const impactedHomeScreenConfig: Array<ImpactedHomeScreenConfig> = [];
        serverRes.forEach(userItem => {
            const userName = userItem.userName;
            const screenTabs = userItem['screen-tab-list'];

            if (screenTabs && screenTabs.length > 0) {
                screenTabs.forEach(screen => {
                    let settingParts: string[] = [];

                    if (screen.tabs_entity && screen.tabs_entity.length > 0) {
                        screen.tabs_entity.forEach(tab => {
                            if (tab.field) {
                                settingParts.push(`<<${tab.name}>>${tab.field}`);
                            }
                        });
                    }

                    impactedHomeScreenConfig.push({
                        name: `${screen.name}(${userName})`,
                        type: businessConstants.impactedConfigType.homeScreen,
                        setting: settingParts.length > 0 ? settingParts.join(',') : null
                    });
                });
            }
        });

        return impactedHomeScreenConfig;
    }
}
